import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'antd';

import Bloco from '../../components/Bloco';

import * as S from './styles';

export function HeaderPainel({
  handelerClick = () => {},
  loadingBtn = false,
  isDasabled,
  atendimentoEmAndamento = false,
}) {
  return (
    <Bloco padding="15px 25px">
      <Row justify="space-between" align="middle">
        <S.Text>
          Para
          <span>
            {atendimentoEmAndamento
              ? ' continuar o atendimento'
              : ' iniciar um atendimento'}
          </span>{' '}
          clique no botão ao lado
        </S.Text>
        <Button
          loading={loadingBtn}
          disabled={isDasabled}
          style={{
            background: '#24A95D',
            border: 'none',
            borderRadius: 0,
            height: 50,
            minWidth: 170,
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '19px',
          }}
          type="primary"
          size="large"
          onClick={handelerClick}
        >
          {atendimentoEmAndamento
            ? 'Continuar atendimento'
            : 'Iniciar atendimento'}
        </Button>
      </Row>
    </Bloco>
  );
}

HeaderPainel.propTypes = {
  handelerClick: PropTypes.func,
  loadingBtn: PropTypes.bool,
  isDasabled: PropTypes.bool,
  atendimentoEmAndamento: PropTypes.bool,
};

HeaderPainel.defaultProps = {
  handelerClick: () => {},
  loadingBtn: false,
  isDasabled: false,
  atendimentoEmAndamento: false,
};
